export const MenuWidth = {
  Desktop: '286px',
  Laptop: '320px',
};
